enum DownloadType {
    RESOURCE = 'resource',
    PLAYLIST = 'playlist'
}

export default DownloadType;